import React from "react";
import InsuranceCategory from "../../types/insuranceCategory";
import useQuickQuoteRedirect from "../../utils/hooks/useQuickQuoteRedirect";

const GoToQuickQuoteButton = ({ payload }) => {
  const { goToQuickQuote } = useQuickQuoteRedirect();

  const insuranceCategory =
    payload?.subIntent === "Car"
      ? InsuranceCategory.car
      : payload?.subIntent === "Bike"
        ? InsuranceCategory.bike
        : payload?.subIntent === "Other Motor"
          ? InsuranceCategory.miscCV
          : payload?.subIntent === "Health"
            ? InsuranceCategory.health
            : payload?.subIntent === "Life"
              ? InsuranceCategory.life
              : payload?.subIntent === "Pet"
                ? InsuranceCategory.pet
                : payload?.subIntent === "GCV"
                  ? InsuranceCategory.gcv
                  : payload?.subIntent === "PCV"
                    ? InsuranceCategory.pcv
                    : payload?.subIntent === "Trailer"
                      ? InsuranceCategory.trailer
                      : null; // Default case, can be handled as needed

  return (
    <button
      onClick={() => goToQuickQuote(insuranceCategory)}
      className="border border-black/20 hover:bg-gray-100 py-0.5 px-2 m-1 rounded-full"
    >
      🌐 Go to Quick Quote
    </button>
  );
};

export default GoToQuickQuoteButton;
